import React from "react";

const Nav = props => {
  const dots = [];
  for (let i = 1; i <= props.totalSteps; i += 1) {
    const isActive = props.currentStep === i;

      dots.push(
        <span
          key={`step-${i}`}
          className={[
            "dot",
            ...Array.from((i < props.currentStep || isActive) && ["active"])
          ].join(" ")}
          // onClick={() => props.goToStep(i)}
        ></span>
      );

  }

  return (
    <div className="d-flex justify-content-center">
      <div className="steps-container d-inline-block">
        <div className="steps d-flex justify-content-center">{dots}</div>
      </div>
    </div>
  );
};

export default Nav;
